import ViewModel from "viewModels/ViewModel";
import navHelper from "services/navHelper";

const CategoryTagView = ViewModel.extend(function CategoryTagView(
    category,
    isCategoryChanged,
    hasCategoryPermission
) {
    const self = this;

    self.id = category.id;
    self.name = category.name;
    self.description = category.description;
    self.isCategoryChanged = isCategoryChanged;
    self.hasCategoryPermission = hasCategoryPermission;

    // link to category editor page
    self.link = navHelper.asHostUrl(
        `directory/#/quality/admin/sta-category-definitions/categoryItem/${self.id}?tab=criteria`
    );
});

export default CategoryTagView;
